import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { RequestService } from "src/app/core/services/request/request.service";
import { ValidateData } from "src/app/core/utils/validate-data";

@Component({
  selector: "app-build-form-request",
  templateUrl: "./build-form-request.component.html",
  styleUrls: ["./build-form-request.component.scss"],
})
export class BuildFormRequestComponent implements OnInit {
  public files: FileList[] = [];

  @Input() idRequestType: number = 1;
  @Input() form: FormGroup;
  @Input() dataJson: any;
  @Input() isArray: boolean = false;
  @Input() responseRequest: any = null;
  @Output() filesOut: EventEmitter<any> = new EventEmitter();

  documents: any = [];
  reason: number;
  messageError: string;
  reasons: any;
  formGroupDocuments: FormGroup;
  constructor(
    public requestService: RequestService,
    private formBuilder: FormBuilder
  ) {}

  ngOnInit() {
    this.changeForm();
  }

  changeForm() {
    if (this.dataJson) {
      this.form.removeControl("documents");
      this.documents = this.dataJson;
      this.formGroupDocuments = this.formBuilder.group({});

      this.documents.forEach((docuemnt) => {
        if (docuemnt.required) {
          this.formGroupDocuments.addControl(
            docuemnt.idForm,
            this.formBuilder.control(null, Validators.required)
          );
        } else {
          this.formGroupDocuments.addControl(
            docuemnt.idForm,
            this.formBuilder.control(null, [])
          );
        }
      });

      this.form.addControl("documents", this.formGroupDocuments);
      this.files = Object.values(this.form.get("documents").value);
    } else {
      if (this.form.contains("documents")) {
        this.form.removeControl("documents");
      }
    }
  }

  async onFileChange(file, documento) {
    let campo = documento.idForm;
    this.messageError = !ValidateData.emptyObject(
      this.files.find((document) => {
        if (document) {
          return document["name"] === file.name;
        }
        return false;
      })
    )
      ? "Nombre de documento repetido"
      : "";

    this.files = Object.values(this.form.get("documents").value);

    if (file && ValidateData.emptyString(this.messageError)) {
      try {
        file.idForm = documento.id;
        file.idTipoDocumentoDigital = documento.idTipoDocumento;

        const documentoProcesado = await this.procesarDocumento(file);

        this.form.get("documents").get(`${campo}`).setValue(documentoProcesado);

        this.files = Object.values(this.form.get("documents").value);
      } catch (error) {
        console.error("Error procesando el documento:", error);
        this.form.get("documents").get(`${campo}`).setValue(null);
      }
    } else {
      this.form.get("documents").get(`${campo}`).setValue(null);
      this.files = Object.values(this.form.get("documents").value);
      file = null;
    }
  }


  delete(fileDelete) {
    this.files = Object.values(this.form.get("documents").value);
  }

  validateString(message: string): boolean {
    return ValidateData.emptyString(message);
  }

  private async procesarDocumento(documento: any): Promise<any> {
    if (!documento) return documento;

    try {
      const contenidoBase64 = await this.convertirArchivoABase64(documento);
      return {
        ...documento,
        base64: contenidoBase64,
        revisionManual: true,
        rutaDocumentoDigital: "",
        idTipoTransaccion: 0,
        esDocumentoDigital: false,
      };
    } catch (error) {
      console.error("Error al convertir el archivo a Base64", error);
      return documento;
    }
  }

  private convertirArchivoABase64(archivo: File): Promise<string> {
    return new Promise((resolver, rechazar) => {
      const lector = new FileReader();

      lector.onload = () => {
        const resultado = lector.result as string;
        const contenidoBase64 = resultado.split(',')[1];
        resolver(contenidoBase64);
      };

      lector.onerror = (error) => {
        console.error("Error al leer el archivo", error);
        rechazar(error);
      };

      lector.readAsDataURL(archivo);
    });
  }
}
